/**
 * CTR Combo Testimonials — carousel controls
 * Desktop arrows in header; mobile arrows + dots below track
 */
(function () {
  'use strict';

  const SELECTOR = '.ctr-combo-testimonials';

  function initSection(section) {
    if (!section || section.dataset.ctmBound === 'true') return;
    section.dataset.ctmBound = 'true';

    const track = section.querySelector('[data-ctm-track]');
    const prevBtns = Array.from(section.querySelectorAll('[data-ctm-prev]'));
    const nextBtns = Array.from(section.querySelectorAll('[data-ctm-next]'));
    const dots = Array.from(section.querySelectorAll('[data-ctm-dot]'));
    const cards = track ? Array.from(track.querySelectorAll('.ctr-combo-testimonials__card')) : [];

    if (!track || cards.length === 0) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function scrollStep() {
      const card = cards[0];
      if (!card) return track.clientWidth * 0.8;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 16;
      return card.getBoundingClientRect().width + gap;
    }

    function currentIndex() {
      const step = scrollStep();
      if (step <= 0) return 0;
      return Math.round(track.scrollLeft / step);
    }

    function maxIndex() {
      return Math.max(0, cards.length - 1);
    }

    function updateControls() {
      const index = Math.min(currentIndex(), maxIndex());
      const atStart = track.scrollLeft <= 4;
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;

      prevBtns.forEach((btn) => {
        btn.disabled = atStart;
        btn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      });
      nextBtns.forEach((btn) => {
        btn.disabled = atEnd;
        btn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      });

      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function goTo(index) {
      const clamped = Math.max(0, Math.min(index, maxIndex()));
      const behavior = prefersReducedMotion.matches ? 'auto' : 'smooth';
      track.scrollTo({ left: clamped * scrollStep(), behavior });
    }

    prevBtns.forEach((btn) => {
      btn.addEventListener('click', () => goTo(currentIndex() - 1));
    });
    nextBtns.forEach((btn) => {
      btn.addEventListener('click', () => goTo(currentIndex() + 1));
    });
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => goTo(i));
    });

    let scrollRaf = 0;
    track.addEventListener(
      'scroll',
      () => {
        if (scrollRaf) cancelAnimationFrame(scrollRaf);
        scrollRaf = requestAnimationFrame(updateControls);
      },
      { passive: true }
    );

    window.addEventListener('resize', updateControls, { passive: true });
    updateControls();
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector?.(SELECTOR) || event.target.closest?.(SELECTOR);
    if (section) {
      section.dataset.ctmBound = '';
      initSection(section);
    }
  });
})();
